<template>
  <span>
    <span
      class="link"
      data-cy="membership-opportunity-link"
      @click="toggleModal"
    >
      {{ membershipOpportunityText }}
    </span>
    <MembershipOpportunityModal
      v-if="membershipOpportunityModal"
      :update-url="updateUrl"
      :membership-opportunity="membershipOpportunity"
      @save-success="emit('save-success')"
      @hide-modal="toggleModal"
    />
  </span>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import MembershipOpportunityModal from "./MembershipOpportunityModal.vue";

const props = defineProps<{
  updateUrl: string;
  membershipOpportunity: boolean;
}>();

const membershipOpportunityText = computed(() =>
  props.membershipOpportunity ? "Yes" : "No"
);

const membershipOpportunityModal = ref(false);

const emit = defineEmits(["hide-modal", "save-success"]);

function toggleModal() {
  membershipOpportunityModal.value = !membershipOpportunityModal.value;
}
</script>
